// import { Outlet } from "react-router-dom";

// export function PrincipalLayout() {
//   return (
//     <div>
//       <Outlet />
//     </div>
//   );
// }

import { AppShell } from "./AppShell";

export function PrincipalLayout() {
  return <AppShell />;
}
